import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import BrandBlogArticlePage from './BrandBlogArticlePage';

export default function BlogArticlePage() {
  return (
    <>
      <Navbar />
      <BrandBlogArticlePage
        publisher="財經錢線"
        brandName="財經錢線"
        englishName="FINLINE"
      />
      <Footer />
    </>
  );
}
